let activeRequests = 0;
let currentMessage = '';
const subscribers = new Set();

const notify = () => {
  const isLoading = activeRequests > 0;
  subscribers.forEach((callback) => callback(isLoading, currentMessage));
};

export const showLoader = () => {
  activeRequests += 1;
  notify();
};

export const hideLoader = () => {
  activeRequests = Math.max(0, activeRequests - 1);
  if (activeRequests === 0) {
    currentMessage = ''; // Clear message when no more active requests
  }
  notify();
};

export const setLoaderMessage = (message) => {
  currentMessage = message;
  notify();
};

export const subscribeToLoader = (callback) => {
  subscribers.add(callback);
  callback(activeRequests > 0, currentMessage);
  return () => {
    subscribers.delete(callback);
  };
};

